import * as THREE from 'three'
import { Shaders } from './shaders/shaders.js'

/**
 * HQ splat 归一化材质（无 EDL），按权重图将累加结果还原为颜色。
 */
export class NormalizationMaterial extends THREE.RawShaderMaterial {
  constructor(_parameters = {}) {
    super()

    const uniforms = {
      uDepthMap: { type: 't', value: null },
      uWeightMap: { type: 't', value: null },
    }

    this.setValues({
      uniforms: uniforms,
      vertexShader: this.getDefines() + Shaders['normalize.vs'],
      fragmentShader: this.getDefines() + Shaders['normalize.fs'],
    })
  }

  /**
   * 构造 shader 宏定义串。
   *
   * @returns 空字符串，子类可扩展
   */
  getDefines() {
    const defines = ''

    return defines
  }

  /** 重新拼装 shader 源码，触发 needsUpdate。 */
  updateShaderSource() {
    const vs = this.getDefines() + Shaders['normalize.vs']
    const fs = this.getDefines() + Shaders['normalize.fs']

    this.setValues({
      vertexShader: vs,
      fragmentShader: fs,
    })

    this.needsUpdate = true
  }
}
